import MergedImagesWrapper from "./MergedImagesWrapper";
import MissingRegionInfoFiller from "./MissingRegionInfoFiller";
import LayoutValueImageSVG from "./LayoutValueImageSVG";
import MissingChannel from "./MissingChannel";
import ScaleToFit from "./ScaleToFit";
import MergedImages from "./MergedImages";
import G from './Getters';
import { useStore, useSelector } from 'react-redux';
import { useRef } from 'react';
import { layersByChannelIdToLayers } from "./utils";

const skipColProj = true;

export default function LayoutValueImageContent({

  nodeId,
  node,
  annotationId,
  value,
  dims,
  padding,

}){


  let store = useStore();
  let state = store.getState();

  let imgRef = useRef();


  let activeAnnotationId = annotationId && !G.isArchived(state,{type:"annotations",_id:annotationId});

  let layers = layersByChannelIdToLayers(value.layersByChannelId);


  if( activeAnnotationId ){

    if( layers.length > 1 ){

      return (
        <div style={{ }} class="full-dim">
          <MergedImagesWrapper {...{
            annotationId,
            channelGroup:value.channelGroup,
            toDraw:layers,
            ...dims,
          }}/>
        </div>

      )
    }else if( !layers.find(x => x.imageId) ){


      return (
          <MissingChannel {...{
            nodeId,
            value,
            ...dims,
          }}/>
      )

      return (
        <ScaleToFit dimensions={[dims.width,dims.height]}>
          <MissingChannel {...{
            nodeId,
            value,
            ...dims,
          }}/>
        </ScaleToFit>
      )
    }else{
      return (
        <LayoutValueImageSVG {...{
          node,
          value,
          annotationId,
          imgRef,
          ...dims,
          width:'100%',
          height:'100%',
        }}/>
      )
    }
  }else{
    return (
      <div class="full-dim rel">
        <MissingRegionInfoFiller {...{nodeId,padding}}/>
      </div>
    )
  }

  

}
